import React, { Component } from "react";
import SideNav, { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
import Grid from "@material-ui/core/Grid";
import { io } from "socket.io-client";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";

import HocView from "./HOC_VIEW";
import { api_base } from "./../../constants/services/api";
import DialogDB from "./../graphics/containers/DialogDB";
import SnackBarDB from "./../container/SnackBarMesseges/containers/SnackBarDB";
import Kml from '../kmlFiles/containers/KmlsContainer';
import Points from '../customPoints/containers/PointsContainer';
// import filtro1 from "./../../images/icons/barra-dash/filtro1.svg";
// import filtro2 from "./../../images/icons/barra-dash/filtro2.svg";
// import filtro3 from "./../../images/icons/barra-dash/handcuffs.svg";
// import filtro4 from "./../../images/icons/barra-dash/filtro4.svg";
// import filtro5 from "./../../images/icons/barra-dash/filtro5.svg";
import ep from "./../../images/icons/barra-dash/street-food.svg";
// import filtro6 from "./../../images/icons/barra-dash/filtro6.svg";
// import filtro7 from "./../../images/icons/barra-dash/filtro7.svg";
// import filtro8 from "./../../images/icons/barra-dash/filtro8.svg";
// import filtro9 from "./../../images/icons/barra-dash/filtro9.svg";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "./../../Actions/Dashboard";
import * as modalActs from "./../../Actions/Modal";

var InitialLoadDashboard = false;
var mapData,
  mapData2,
  gaugesData,
  sicData,
  cnpData,
  caracterizacionData,
  thoras,
  tedad,
  partediarioData;
var defaultSelection = {
  bandera: true,
  phenomenes: {},
  characteristics: {
    date: {
      days: null,
      months: [],
      years: [2019],
      ranges: [],
      semesters: [],
    },
    genero: [],
    jornada: [],
    grupoEtario: [],
    estadoCivil: [],
    escolaridad: [],
    medioTransporteVictima: [],
    medioTransporteVictimario: [],
    ocupacion: [],
    tipoZona: [],
    tipositio: [],
    tipoArma: [],
    modalidad: [],
    clasebien: [],
    marca: [],
    color: [],
    modelo: [],
    linea: [],
  },
  location: {
    comuna: [],
    barrio: [],
    urbanizacion: [],
    cuadrante: [],
    municipio: [],
  },
};
class Dashboard extends Component {
  state = {
    selected: "dashboard",
    seleccion1: {},
    seleccion2: {},
    seleccion3: {},
    seleccion4: {},
    seleccion5: {},
    gerencias: {},
    inicial: defaultSelection,
    expanded: false,
    mapData,
    mapData2,
    topcomuna: null,
    total: [],
    donas: [],
    tops: [],
    lineas: [],
    matrices: [],
    thoras,
    tedad,
    partediarioData,
    gaugesData,
    sicData,
    caracterizacionData,
    cnpData,
    show_filter: {},
    send: {}, //CAMBAIR ESTE DINAMICAMENTE
    selectionResult: {},
    detailData: {},
    dialogTitle: "",
    open: false,
    openSnackBar: false,
    messegeSnackBar: "",
    typeSnackBar: "error",
    showMessageResult: false,
    firstLoad: true,
  };
  polygon = [];

  setNull() {
    this.setState({
      mapData: null,
      thoras: null,
      tedad: null,
      gaugesData: null,
      topcomuna: null,
      total: [],
      donas: [],
      tops: [],
      lineas: [],
      matrices: [],
    });
  }

  closeMessageResult = () => {
    this.setState({ showMessageResult: false });
  };

  componentDidUpdate() {
    if (JSON.stringify(this.props.dashboard.filter) !== this.filter) {
      this.filter = JSON.stringify(this.props.dashboard.filter);
      this.setNull();
      this.now = new Date().getTime().toString();
      this.socket.emit(
        "evento",
        {
          ...this.props.dashboard.filter,
          polygon: this.polygon,
          type: "normal",
          now: this.now,
          token: this.props.session.token,
        }
      );
    }
    try {
      if (this.iconCreateInform.classList.contains("animate-collect")) {
        setTimeout(() => {
          try {
            this.iconCreateInform.classList.remove("animate-collect");
          } catch (error) {
            return;
          }
        }, 1000);
      }
    } catch (error) { }
  }

  componentDidMount() {
    this.filter = JSON.stringify(this.props.dashboard.filter);
    // this.socket = io(api_base);
    this.socket = io(api_base + "/api/v1/dash/filters");
    this.socket.on(this.props.dashboard.filter.socketPath, (data) => this.recieveData(data))
    this.now = new Date().getTime().toString();
    // console.log('emit',
    //   {
    //     ...this.props.dashboard.filter,
    //     polygon: this.polygon,
    //     type: "normal",
    //     now: this.now,
    //     token: this.props.session.token,
    //   })
    this.socket.emit(
      "evento",
      {
        ...this.props.dashboard.filter,
        polygon: this.polygon,
        type: "normal",
        now: this.now,
        token: this.props.session.token,
      }
    );
  }

  componentWillUnmount() {
    this.socket.disconnect();
  }

  recieveData = (resp) => {
    let data = resp;
    // let data = JSON.parse(resp);
    console.log("data", data);
    if (data.notToken) {
      this.props.sessionActions.closeSession();
      return;
    }
    if (data.now !== this.now) return;

    // this.handleOpenSnackBar('Consulta exitosa', 'success')
    switch (data.type) {
      case "gauges": this.setState({ gaugesData: data.data, firstLoad: true }); break;
      case "location": this.setState({ mapData: data.data }); break;
      case "edad": this.setState({ tedad: data.data, firstLoad: false }); break;
      case "hours": this.setState({ thoras: data.data, firstLoad: false }); break;
      case "comuna": this.setState({ topcomuna: data.data, firstLoad: false }); break;
      case "verMas": this.setState({ detailData: data.data }); break;
      // case "polygon": break;
      // case "polygon": this.setState({ mapData: data.data }); break;
      default:
        let variable = this.state[data.type]
        variable.push(data.data)
        this.setState({ [data.type]: variable, firstLoad: false });
        break;
    }
  };

  onSelect = (selected) => {
    console.log("este clic", selected);
    if (selected === "Consejo/ingresar") {
      this.props.history.push("/Consejo-Seguridad-ingresar");
    }
    if (selected === "seleccion4") {
      this.props.actions.activePage("/piscc");
      this.props.history.push("/piscc");
    }
    if (selected === "seleccion3") {
      this.props.actions.activePage("/cruce");
      this.props.history.push("/cruce");
    }
    if (selected === "seleccion5") {
      this.props.actions.activePage("/percepcion-ciudadana");
      this.props.history.push("/percepcion-ciudadana");
    }
    if (selected === "descargar") {
      const year = this.props.dashboard.filter.year.length ? this.props.dashboard.filter.year[this.props.dashboard.filter.year.length - 1] : new Date().getFullYear()
      let type = this.props.dashboard.filter.fuenteDato.length ? this.props.dashboard.filter.fuenteDato[0] : 1;
      const text = type === 1 ? 'siedco' : type === 2 ? 'secad' : 'capturas'
      const url = `${api_base}/api/v1/dashboard/getEcxelFile/${year}/${type}/${text}`
      window.open(url, '_blank');
      this.setState({ selected: "dashboard" });
      return
    }
    if (selected === "add_layer") {
      this.props.modalActions.openModal(<Kml onClose={this.props.modalActions.closeModal} signalUpdate={this.props.actions.signalUpdate} />)
      this.setState({ selected: "dashboard" });
      return
    }
    if (selected === "add_point") {
      this.props.modalActions.openModal(<Points />)
      this.setState({ selected: "dashboard" });
      return
    }
    if (selected === "full_screen") {
      const elem = document.getElementById('map');
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
      }
      this.setState({ selected: "dashboard" });
      return
    }
    if (selected === "seleccion2") {
      this.props.actions.selectFilterFenomene({ id: 2, value: 'SECAD' }, 'fuenteDato')
      this.props.actions.selectFilterFenomene({ id: 2, value: 'SECAD' }, 'fuenteDato')
      this.setState({ selected: "dashboard" });
      return
    }
    if (selected === "operatividad") {
      this.props.actions.selectFilterFenomene({ id: 1, value: 'DENUNCIAS' }, 'denuncias')
      this.props.actions.selectFilterFenomene({ id: 1, value: 'DENUNCIAS' }, 'denuncias')
      this.setState({ selected: "dashboard" });
      return
    }
    if (selected === "comparendos") {
      this.props.actions.selectFilterFenomene({ id: 1, value: 'COMPARENDOS' }, 'comparendos')
      this.props.actions.selectFilterFenomene({ id: 1, value: 'COMPARENDOS' }, 'comparendos')
      this.setState({ selected: "dashboard" });
      return
    }
    if (selected === "capturas") {
      this.props.actions.selectFilterFenomene({ id: 1, value: 'CAPTURAS' }, 'capturas')
      this.props.actions.selectFilterFenomene({ id: 1, value: 'CAPTURAS' }, 'capturas')
      this.setState({ selected: "dashboard" });
      return
    }
    if (selected === "incautaciones") {
      this.props.actions.selectFilterFenomene({ id: 1, value: 'INCAUTACIONES' }, 'incautaciones')
      this.props.actions.selectFilterFenomene({ id: 1, value: 'INCAUTACIONES' }, 'incautaciones')
      this.setState({ selected: "dashboard" });
      return
    }
    if (selected === "recuperaciones") {
      this.props.actions.selectFilterFenomene({ id: 1, value: 'RECUPERACIONES' }, 'recuperaciones')
      this.props.actions.selectFilterFenomene({ id: 1, value: 'RECUPERACIONES' }, 'recuperaciones')
      this.setState({ selected: "dashboard" });
      return
    }
    if (selected === "seleccionEP") {
      console.log('EEEPPP')
      this.props.actions.selectFilterFenomene({ id: 1, value: 'ESPACIO PÚBLICO' }, 'ep')
      this.props.actions.selectFilterFenomene({ id: 1, value: 'ESPACIO PÚBLICO' }, 'ep')
      this.setState({ selected: "dashboard" });
      return
    }

    if (selected === this.state.selected) this.setState({ selected: "dashboard" });
    else this.setState({ selected: selected });
  };

  onToggle = (expanded) => {
    this.setState({ expanded: expanded });
  };

  seleccionActual = () => { };

  sendPolygon = (coords) => {
    this.polygon = coords
    this.props.actions.selectFilter({ id: 1, value: 'Poligono' }, 'poligono');
    // console.log(polygon);
    // this.now = new Date().getTime().toString();
    // this.socket.emit(
    //   "evento",
    //   {
    //     ...this.props.dashboard.filter,
    //     polygon,
    //     type: "polygon",
    //     now: this.now,
    //     token: this.props.session.user.token,
    //   }
    // );
  }

  sendFilter = (selected) => {
    //se cambia el state par acada xpand
    var seleccionAux;

    if (!InitialLoadDashboard) {
      return this.state.inicial;
    } else if (InitialLoadDashboard && selected === "dashboard") {
      return seleccionAux;
    } else {
      switch (selected) {
        case "seleccion1":
          return this.state.seleccion1;
        // case "seleccion2":
        //   return this.state.seleccion2;
        case "seleccion3":
          return this.state.seleccion3;
        case "seleccion4":
          return this.state.seleccion4;
        case "seleccion5":
          return this.state.seleccion5;
        default:
      }
    }
  };

  handleOpenDialog = (title, graph, seeTen = false) => {
    console.log('O D', title, graph)
    this.setState({ open: true, dialogTitle: title, detailData: {} });
    if (graph === "linea_fenomeno_fiveyears") {
      this.setState({
        detailData: { dataSetTimeLine: this.state.lyears, dataSetDon: [] },
      });
      return;
    } else if (graph === "linea_fenomeno_months") {
      this.setState({
        detailData: { dataSetTimeLine: this.state.lyearmonth, dataSetDon: [] },
      });
      return;
    }
    if (seeTen) {
      let data = this.state.tops.filter(f => f[0].name === graph).reduce((pre, cur) => {
        return [
          {
            ...cur[0],
            dataSet: cur[0].dataSet.slice(0, 10)
          }
        ]
      }, []);
      // let seeTen = graph.split('total_')[1];
      console.log(this.state)
      console.log(data)
      this.setState({
        detailData: { dataSetTenBars: data, dataSetDon: [] },
      });
      return;

    }

    this.now = new Date().getTime().toString();
    this.socket.emit(
      "evento",
      {
        ...this.props.dashboard.filter,
        polygon: this.polygon,
        type: "verMas" + graph,
        now: this.now,
        token: this.props.session.token,
      }
    );
  };

  handleCloseDialog = () => {
    this.setState({ open: false, dataSetDon: [], dataSetTimeLine: [], dataSetTenBars: [] });
  };

  handleCloseSnackBar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ openSnackBar: false });
  };
  handleOpenSnackBar = (messege, type) => {
    this.setState({
      openSnackBar: true,
      messegeSnackBar: messege,
      typeSnackBar: type,
    });
  };

  resetFilter = (seleccionDefault) => { };

  handlehandleCloseMenu = () => {
    this.setState({
      selected: "dashboard",
    });
  };
  getGrapchisCounter = () => {
    try {
      if (!!this.props.graphicsCount) {
        this.iconCreateInform.classList.add("animate-collect");
        this.iconCreateInform.classList.add("show-count");
      } else {
        this.iconCreateInform.classList.remove("show-count");
      }
    } catch (e) { }
  };

  setIconCreateInformRef = (element) => {
    this.iconCreateInform = element;
  };

  render() {
    this.getGrapchisCounter();
    const { expanded, selected } = this.state;
    const setNavIcon = (ops) => {
      return (
        <NavItem eventKey={ops.key}>
          <NavIcon>
            <i
              className="filter-icon"
              style={{ fontSize: "1.75em", verticalAlign: "middle" }}
              data-graphics={this.props.graphicsCount}
              ref={this.setIconCreateInformRef}
              title={ops.title}
            >
              {
                ops.faIcon ? <i className={ops.icon} style={{ color: 'white' }}></i> : <img src={ops.icon} alt="filtro"></img>
              }
            </i>
          </NavIcon>
          <NavText style={{ paddingRight: 16 }}>
            {ops.text}
          </NavText>
        </NavItem>
      )
    }
    return (
      <Grid container>
        <SideNav
          onSelect={this.onSelect}
          onToggle={this.onToggle}
          className={
            this.props.generals.noHeader ? "sidenav no-header" : "sidenav"
          }
        >
          <SideNav.Toggle />
          <SideNav.Nav selected={selected}>
            {
              setNavIcon({
                key: 'seleccion1',
                faIcon: true,
                title: 'Filtro',
                icon: 'fas fa-filter',
                text: 'Filtro'
              })
            }
            {
              setNavIcon({
                key: 'seleccionEP',
                icon: ep,
                title: 'Espacio Público',
                text: 'Espacio Público'
              })
            }
            {/* {
              setNavIcon({
                key: 'seleccion3',
                faIcon: true,
                icon: 'fas fa-chart-line',
                title: 'Cruce de Datos',
                text: 'Cruce'
              })
            }
            {
              setNavIcon({
                key: 'seleccion4',
                icon: filtro4,
                title: 'PISCC',
                text: 'PISCC'
              })
            }
            {
              setNavIcon({
                key: 'seleccion5',
                icon: filtro5,
                title: 'Percepción',
                text: 'Percepción ciudadana'
              })
            } */}
            {/* {!this.props.generals.noHeader &&
              setNavIcon({
                key: 'descargar',
                faIcon: true,
                icon: "fas fa-file-download",
                title: 'Descarga',
                text: 'Descarga Excel'
              })
            } */}
            {!this.props.generals.noHeader &&
              setNavIcon({
                key: 'add_layer',
                faIcon: true,
                icon: "fas fa-layer-group",
                title: 'Agregar capa',
                text: 'Agregar Capa'
              })
            }
            {!this.props.generals.noHeader &&
              setNavIcon({
                key: 'add_point',
                faIcon: true,
                icon: "fas fa-map-marked-alt",
                title: 'Agregar punto',
                text: 'Agregar Punto'
              })
            }
            {
              setNavIcon({
                key: 'full_screen',
                faIcon: true,
                icon: "fas fa-expand",
                title: 'Pantalla completa',
                text: 'Pantalla completa'
              })
            }
          </SideNav.Nav>
        </SideNav>
        <Grid container className="hoc-view-container">
          <Grid xs={12} item>
            <HocView
              id={"hoc"}
              expanded={expanded}
              CloseMenu={this.handlehandleCloseMenu}
              select={this.state.selected}
              filterProps={this.sendFilter(this.state.selected)}
              seleccionInicial={this.state.inicial}
              cargaDashboard={1}
              seleccionActual={this.seleccionActual}
              mapResult={this.state.mapData}
              topcomuna={this.state.topcomuna}
              donas={this.state.donas}
              totales={this.state.total}
              lineas={this.state.lineas}
              matrices={this.state.matrices}
              tops={this.state.tops}
              timeHorasResult={this.state.thoras}
              timeEdadResult={this.state.tedad}
              partediarioResult={this.state.partediarioData}
              guagesResult={this.state.gaugesData}
              sicResult={this.state.sicData}
              caracterizacionResult={this.state.caracterizacionData}
              cnpResult={this.state.cnpData}
              rumbaSeguraResult={this.state.rumbaSegura}
              dataMapNeigborhoods={this.updateDataMapNeigborhoods}
              dataMapComunes={this.updateDataMapComunes}
              openDialog={this.handleOpenDialog}
              closeMessageResult={this.closeMessageResult}
              showMessageResult={this.state.showMessageResult}
              ResetInicialFilter={this.resetFilter}
              firstLoad={this.state.firstLoad}
              sendPolygon={this.sendPolygon}
            ></HocView>
          </Grid>
        </Grid>
        <DialogDB
          open={this.state.open}
          onClose={this.handleCloseDialog}
          scroll={"body"}
          detailData={this.state.detailData}
          title={this.state.dialogTitle}
        ></DialogDB>

        <SnackBarDB
          open={this.state.openSnackBar}
          onClose={this.handleCloseSnackBar}
          message={this.state.messegeSnackBar}
          type={this.state.typeSnackBar}
        />
      </Grid>
    );
  }
}

function mapStateToProprs(state) {
  return {
    dashboard: state.dashboard,
    graphicsCount: state.dashboard.graphicsAcucumulated.length,
    generals: state.generals,
    session: state.session,
  };
}

function mapDispathToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    modalActions: bindActionCreators(modalActs, dispatch),
  };
}

export default connect(mapStateToProprs, mapDispathToProps)(Dashboard);
